import { en } from './en_EN'
import { de } from './de_DE'

export default { en, de }